// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useEffect } from 'react';
import API_BASE_URL from '../../config/api';

function FlashcardsView({ topic, token }) {
    const [concepts, setConcepts] = useState([]);
    const [selectedConceptId, setSelectedConceptId] = useState('');
    const [flashcard, setFlashcard] = useState(null);
    const [flipped, setFlipped] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingConcepts, setLoadingConcepts] = useState(true);
    const [error, setError] = useState('');

    const safeFetch = async (url, options) => {
        const res = await fetch(url, options);
        const text = await res.text();
        const trimmed = text ? text.trim() : '';
        if (!trimmed || trimmed === 'undefined') return { success: false, message: 'Empty response' };
        return JSON.parse(trimmed);
    };

    // Fetch concepts when topic changes
    useEffect(() => {
        setFlashcard(null);
        setFlipped(false);
        setError('');
        setSelectedConceptId('');
        setLoadingConcepts(true);

        safeFetch(`${API_BASE_URL}/learnwithai/concepts?topic=${encodeURIComponent(topic)}`, {
            headers: { 'Authorization': `Bearer ${token}` },
        })
            .then(data => {
                if (data.success && data.data.length > 0) {
                    setConcepts(data.data);
                    setSelectedConceptId(data.data[0]._id);
                } else {
                    setConcepts([]);
                }
            })
            .catch(() => setError('Failed to load concepts.'))
            .finally(() => setLoadingConcepts(false));
    }, [topic, token]); // eslint-disable-line react-hooks/exhaustive-deps

    const generate = async () => {
        if (!selectedConceptId || loading) return;
        setLoading(true);
        setFlashcard(null);
        setFlipped(false);
        setError('');

        try {
            const data = await safeFetch(`${API_BASE_URL}/learnwithai/ai/flashcard`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ topic, conceptId: selectedConceptId }),
            });

            if (data.success) {
                setFlashcard(data.data.flashcard);
            } else {
                setError(data.message || 'Failed to generate flashcard.');
            }
        } catch {
            setError('Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (loadingConcepts) {
        return (
            <div className="lw-empty">
                <span className="lw-empty-icon">⏳</span>
                <p>Loading concepts…</p>
            </div>
        );
    }

    if (!concepts.length) {
        return (
            <div className="lw-empty">
                <span className="lw-empty-icon">📝</span>
                <p>No concepts found for <strong>{topic}</strong>.</p>
            </div>
        );
    }

    return (
        <div className="lw-flashcards">
            <div className="lw-fc-controls">
                <select
                    value={selectedConceptId}
                    onChange={e => {
                        setSelectedConceptId(e.target.value);
                        setFlashcard(null);
                        setFlipped(false);
                    }}
                >
                    {concepts.map(c => (
                        <option key={c._id} value={c._id}>
                            {c.title}
                        </option>
                    ))}
                </select>
                <button
                    className="lw-btn-primary"
                    onClick={generate}
                    disabled={loading}
                >
                    {loading ? 'Generating…' : 'Generate Card'}
                </button>
            </div>

            {error && <div className="lw-error">{error}</div>}

            {!flashcard && !loading && (
                <div className="lw-empty">
                    <span className="lw-empty-icon">🃏</span>
                    <p>Select a concept and click <strong>Generate Card</strong></p>
                </div>
            )}

            {flashcard && (
                <div
                    className="lw-card-scene"
                    onClick={() => setFlipped(f => !f)}
                    title="Click to flip"
                >
                    <div className={`lw-card${flipped ? ' flipped' : ''}`}>
                        <div className="lw-card-face lw-card-front">
                            <div style={{ fontSize: '0.95rem', fontWeight: 500 }}>
                                {flashcard.front || 'Question'}
                            </div>
                            <div className="lw-card-hint">Click to reveal answer</div>
                        </div>
                        <div className="lw-card-face lw-card-back">
                            <div style={{ fontSize: '0.93rem', lineHeight: 1.6 }}>
                                {flashcard.back || 'Answer'}
                            </div>
                            <div className="lw-card-hint">Click to flip back</div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default FlashcardsView;
